import React,{Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../../actions';
import {Link} from 'react-router';
import Footer from './footer.js';
import $ from 'jquery';
import Swiper from 'react-id-swiper';
import Icon, { FontAwesome, Feather } from 'react-web-vector-icons';
import {Modal, Tab,Tabs, Col, } from 'react-bootstrap';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
class Search extends Component{

  constructor(props){
    super(props);
    this.state={
      status: 'unfocus',
      keyword: '',
      viewmore_status:false,
      isLoading:false,
      isSearched:false
    }
    this.deleteSearchItem=this.deleteSearchItem.bind(this);
    this.viewmore=this.viewmore.bind(this);
    this.saveSearch=this.saveSearch.bind(this);
    this.handleClick=this.handleClick.bind(this);

  }
  deleteSearchItem(del_id)
  {
    console.log(del_id);
      if(localStorage.user_id)
      {
        var uid=localStorage.user_id;
      }
      else
      {
        uid=0;
      }
      var data1={from:'mobile_web',uid:uid,token:localStorage.token,id:del_id};
      var data2=JSON.stringify(data1);
      $.ajax({
        method:'POST',
        dataType:'json',
        url:baseUrl+'deleteSearch',
        data:{req:data2},
        success:function(data)
        {
            if(data.status==='success')
            {
              this.props.trends();
            }
        }.bind(this),
        error:function(err)
        {

        }
      })
  }
  viewmore()
  {
    this.setState({
      viewmore_status:!this.state.viewmore_status,
    });
  }
  componentDidMount(){
    this.refs.keyword.focus();
    //this.props.clear_state();
  }
  onFocus(event){
    this.setState({
     // status: 'focus',
      keyword: event.target.value
    })
  }
  
  onChangeKey(event)
  {
    // this.props.clear_state();
    // if(event.target.value ==""){
    //   this.props.trends();
    // }else{
    //   this.props.search_products(event.target.value);     
    // }
      this.setState({
        keyword: event.target.value,
        status: 'focus',
      });     

  }
  onBlur()
  {  
    // this.setState({
    //   status: 'unfocus'
    // });
  }
  resetKey(){
    this.props.trends();
    this.setState({
       keyword:'',
       status: 'unfocus',
       isSearched:false
    });
    // this.state.keyword = ''
  }
  componentWillMount(){
    this.props.trends();    
  }
  saveSearch(uid,search_id,type){
      if(uid != 0){
        var data1={from:'mobile_web',id:uid,token:localStorage.token,search_id:search_id,type:type};
        var data2=JSON.stringify(data1);
        $.ajax({
          method:'POST',
          dataType:'json',
          url:baseUrl+'saveSearch',
          data:{req:data2},
          success:function(data)
          {
              if(data.status==='success')
              {
              }
          }.bind(this),
          error:function(err)
          {

          }
        })
      }
  }
handleClick = event => {
  console.log(event);
}  
  
render(){
  var recent_search = "";
  var that = this;
  $(document).off('keyup', '#srh_input_box');
  $(document).on('keyup','#srh_input_box',function(){
    var string = $(this).val();
    console.log(string);
    that.props.clear_state();
    if(string == "") {
            that.setState({isSearched:false});
            that.setState({isLoading:false});      
            that.props.trends();
    }else{
            that.setState({isSearched:true});      
            that.props.search_products(string);
        }
    
  });
  // $('body').css('background','#E0E1E3');
  // $(window).load(function() {
  //   $('body').css('background','#E0E1E3');
  // });
  const params = {
    paginationClickable: true,
    spaceBetween: 10,
    slidesPerView: 4.5
  }  

  if(this.state.status === "focus"){
    var input_keys =<button onClick={this.resetKey.bind(this)} type="button" className="btn btn-default srch_btn"><img className="img_srh" src={baseAssets+'images/web_imgs/close_button.png'} alt=""/></button>;
  }
  else{
     input_keys =''; 
  }
  
  if(this.props.brands.length > 0){ var brands = (<h2>Brands</h2>)} 
  if(this.props.products.length > 0){ var products = (<span><div className="clr"></div><h2 style={{paddingTop:'10px'}}>Products</h2></span>)}  
  if(this.props.categories){
    if(this.props.categories.length > 0){
      var categories = (<span><div className="clr"></div><h2 style={{paddingTop:'10px'}}>Categories</h2></span>)     
    }  
  } 
  var trends = '';
  if(this.props.trendings.length > 0 && !this.state.isSearched){ 
    trends = (<h2>Trending Searches</h2>);
  }
  else {
    trends = '';
  }
   if(this.props.popular_brands.length > 0){ 
    var pop_brnds = (<h2>Popular Brand Searches </h2>);
  }
  else {
    pop_brnds = '';
  }
  var that = this;
  var brands_list=this.props.brands.map(function(brand,index){
        pop_brnds='';
        //trends='';
        return(
           <Link to={"/pdeals/"+brand.url_dtype_name+"/"+brand.url_brand_name+"/"+brand.id +"/"+brand.type+"/"+brand.dtype} onClick={()=>{that.saveSearch(localStorage.user_id,brand.id,3)}}>
            <Col md={12} sm={12} xs={12} className="srh_list_item">
              <Col md={2} sm={2} xs={2} className="">
                <img src={brand.logo !=='' && brand.logo !== null ? baseAssets+'images/brand_icons/'+brand.logo : baseAssets+'icons/web_icons/noImage.png'} role="presentation" alt=" " width='20px'/>
              </Col>
              <Col md={10} sm={10} xs={10} className="">
                <div className="srh_cnt_all">{brand.category_name}</div>
              </Col>
              <Col md={1} sm={1} xs={1} className="srh_deal_cnt">
                <i>{brand.dealcount}</i>
              </Col>                            
            </Col>
          </Link>  
         )
       }); 
  var product_list=this.props.products.map(function(product,index){
      // var link = this.props.params.Type;
  //trends= '';
  pop_brnds='';
  trendings_list=''
      return(
          <Link to={product.dealcount > 1 ? "/subdeals/"+product.url_dtype_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.id : "/pdetails/"+product.url_dtype_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.id+"/"+product.deal_id} onClick={()=>{that.saveSearch(localStorage.user_id,product.id,1)}}>
            <Col md={12} sm={12} xs={12} className="srh_list_item">
              <Col md={2} sm={2} xs={2} className="">
                  <img src={product.logo !=='' && product.logo!== null ? baseAssets+'images/product_imgs/thumbnails/'+product.logo : baseAssets+'icons/web_icons/noImage.png'} alt=" " width='20px'/>
              </Col>
              <Col md={10} sm={10} xs={10} className="">
                <div className="srh_cnt_all">{product.category_name}</div>
              </Col>
              <Col md={1} sm={1} xs={1} className="srh_deal_cnt">
                <i>{product.dealcount}</i>
              </Col>                            
            </Col>
          </Link>              
         )

       }) ; 
       
   if(this.props.categories)
   {
    if(this.props.categories.length > 0)
    {
      var categories_list=this.props.categories.map(function(category,index){
        // var link = this.props.params.Type;
      //trends='';
      pop_brnds='';
      return(
              <li className="cat_list_hide">
               <Link to={"/pdeals/"+category.url_dtype_name+"/"+category.url_cat_name+"/"+category.id+"/"+category.type+"/"+category.dtype} onClick={()=>{that.saveSearch(localStorage.user_id,category.id,2)}}>
                <img src={category.logo !=='' && category.logo !==null ?  baseAssets+'images/icons/'+category.logo : baseAssets+'icons/web_icons/noImage.png'}  alt=" " width='20px'/>
                {category.category_name} <i>{category.dealcount}</i>
                </Link>
              </li>
           )
         }) ;      
      }
   }
 
  if(!this.state.keyword.length > 0)
  {
    var trendings_list=this.props.trendings.map(function(trend,index){
          return(
              <li className="trend_list_hide">
                  {trend.type ==="product" ?  <Link to={trend.type === "product" && trend.dealcount > 1  ? "/subdeals/"+trend.url_dtype_name+"/"+trend.url_cat_name+"/"+trend.url_product_name+"/"+trend.id : "/pdetails/"+trend.url_dtype_name+"/"+trend.url_cat_name+"/"+trend.url_product_name+"/"+trend.id+"/"+trend.deal_id } >
                        <img src={trend.logo !==null && trend.logo!=='' ? baseAssets+'images/product_imgs/'+trend.logo : baseAssets+'icons/web_icons/noImage.png'}  alt="" width='20px'/>                  
                  <span style={{position:'relative',top:'2'}}>{trend.category_name}</span></Link> : ''}
                  {trend.type === 'brand' ? <Link to={"/pdeals/"+trend.url_dtype_name+"/"+trend.url_name+"/"+trend.id+"/"+trend.type+"/"+trend.dtype} >
                        <img src={trend.logo !=='' && trend.logo!==null ? baseAssets+'images/brand_icons/'+trend.logo : baseAssets+'icons/web_icons/noImage.png'}  alt="" width='20px' style={{paddingLeft:'5px'}}/>  
                  {trend.category_name}</Link> : ''}
              </li>
           )
         });

    var popular_brands_list=this.props.popular_brands.map(function(brand,index){
      return(
        <li>
            <Link to={"/pdeals/"+brand.url_dtype_name+"/"+brand.url_name+"/"+brand.id+"/"+brand.type+"/"+brand.dtype_id}>
                <p className="pop_brnd_img"><img src={brand.logo !=='' && brand.logo!==null ? baseAssets+'images/brand_icons/'+brand.logo : baseAssets+'icons/web_icons/noImage.png'} alt=" " /></p>
                <p className="pop_brnd_name">{brand.category_name}</p>
            </Link>
        </li>
      )
      });

    if(this.props.recent_search.length > 0 &&  this.props.recent_search.length > 3)
    {
        var recent_search=this.props.recent_search.map(function(item,index){
           
            var data=<div className="recent_search_list">
                        {item.type ==="product" ? <li>
                        <div className="">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                              style={{position:'absolute',right:0,top:-3,cursor:'pointer'}}
                            />
                        </span>
                        </div>       
                        <Link to={item.type === "product" && item.dealcount > 1  ? "/subdeals/"+item.url_dtype_name+"/"+item.url_cat_name+"/"+item.url_name+"/"+item.id : "/pdetails/"+item.url_dtype_name+"/"+item.url_cat_name+"/"+item.url_brand_name+"/"+item.url_product_name+"/"+item.id+"/"+item.deal_id}>                                             
                            <div className="recent_search_thumbnail">
                            <img src={item.logo !==null && item.logo!=='' ? baseAssets+'images/product_imgs/'+item.logo : baseAssets+'icons/web_icons/noImage.png'}  alt="" width='40px'/>
                            </div>
                            <h4>{item.category_name}</h4>                            
                        </Link>                        
                      </li> : ''}
                        
                        {item.type === 'brand' ? <li>
                        <div className="">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                              style={{position:'absolute',right:0,top:-3,cursor:'pointer'}}
                            />
                        </span>
                        </div>                            
                        <Link to={item.url}>                         
                            <div className="recent_search_thumbnail">                        
                              <img src={item.logo !=='' && item.logo!==null ? baseAssets+'images/brand_icons/'+item.logo : baseAssets+'icons/web_icons/noImage.png'} alt="" width='40px'/>                          
                             </div> 
                            <h4>{item.category_name}</h4> 
                            </Link></li> : ''}

                        {item.type==='Pcategory' ? <li>
                        <div className="">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                              style={{position:'absolute',right:0,top:-3,cursor:'pointer'}}                              
                            />
                        </span>
                        </div>                        
                        <Link to={'/pdeals/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.id+'/Pcategory/'+item.dtype}>                             
                          <div className="recent_search_thumbnail">                          
                          <img src={item.logo !=='' && item.logo!==null ? baseAssets+'images/icons/'+item.logo : baseAssets+'icons/web_icons/noImage.png'} alt="" width='40px'/>                                               
                          </div>
                          <h4>{item.category_name}</h4> 
                        </Link></li> : ''}
                    </div>
            return(data);
          }.bind(this));

    }
    else if(this.props.recent_search.length < 4)
    {
        var recent_search=this.props.recent_search.map(function(item,index){   
            var data= ''
            if(item.type ==="product"){
              data= <li className="recent_search_list">
                      <div>
                       <div className="recent_close_icon">
                         <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                            />
                        </span>
                        </div>
                        <Link to={item.type === "product" && item.dealcount > 1  ? "/subdeals/"+item.url_dtype_name+"/"+item.url_cat_name+"/"+item.url_name+"/"+item.id : "/pdetails/"+item.url_dtype_name+"/"+item.url_cat_name+"/"+item.url_name+"/"+item.id+"/"+item.deal_id}>
                            <div className="recent_search_thumbnail">
                            <img src={item.logo !==null && item.logo!=='' ? baseAssets+'images/product_imgs/'+item.logo : baseAssets+'icons/web_icons/noImage.png'}  alt="" width='40px'/>                            
                            </div>
                            <h4>{item.category_name}</h4>                            
                        </Link>
                      </div>
                    </li>                     
            }
            if(item.type ==="brand"){
              alert(item.type);
              data= <li className="recent_search_list">
                      <div>
                        <div className="recent_close_icon">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                            />
                        </span>
                        </div>
                        <Link to={"/pdeals/"+item.url_dtype_name+"/"+item.url_name+"/"+item.id+"/"+item.type+"/"+item.dtype}>
                            <div className="recent_search_thumbnail">                        
                              <img src={item.logo !=='' && item.logo!==null ? baseAssets+'images/brand_icons/'+item.logo : baseAssets+'icons/web_icons/noImage.png'} alt="" width='40px'/>                               
                             </div> 
                            <h4>{item.category_name}</h4> 
                            </Link>
                      </div>              
                    </li>              
            }
            if(item.type ==="Pcategory"){
                      <div>
                        <div className="recent_close_icon">
                        <span onClick={()=>{this.deleteSearchItem(item.del_id)}}>
                          <Icon
                              name='close-circle'
                              font='MaterialCommunityIcons'
                              color='#9999'
                              size={16}
                            />
                        </span>
                        </div>
                        <Link to={'/pdeals/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.id+'/Pcategory/'+item.dtype}>
                          <div className="recent_search_thumbnail">                          
                          <img src={item.logo !=='' && item.logo!==null ? baseAssets+'images/icons/'+item.logo : baseAssets+'icons/web_icons/noImage.png'} alt="" width='40px'/>                                                    
                          </div>
                          <h4>{item.category_name}</h4> 
                        </Link>
                      </div>             
            }
            return(data);
          }.bind(this));
    }else{
        recent_search='';      
    }
}
return (
  <div className="mob_deals mob_search_page">
      <div className="page_hdr">
        <div className="container-fluid">
          <div className="page_hdr">
            <div className="container-fluid">
                <h5 style={{float: 'left',paddingTop: '10px'}}><Link to={"/"}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link></h5>
                <div className="hdr_srch">
                    <form className="navbar-form navbar-left">
                      <div className="form-group">
                          <input id="srh_input_box" ref="keyword" onChange={this.onChangeKey.bind(this)} onFocus={this.onFocus.bind(this) } onBlur={ this.onBlur.bind(this) }  value={this.state.keyword} className="form-control" placeholder="Search brands, products and categories" />
                      </div>
                      {input_keys}    
                    </form>
                </div>
            </div>
        </div>
        </div>
      </div>
      <div>&nbsp;</div>
      {this.props.isLoading ?      
      <div className="pag_cntnt srch_page pag_cntnt2 " style={{backgroundColor:'#e0e1e3',marginTop:'10px'}}>
          <div className="container-fluid">
            {((this.props.brands.length > 0 || this.props.products.length > 0 || this.props.categories.length > 0) && this.state.isSearched) ?  
            <div className="" style={{backgroundColor:'#fff',padding: '8px'}} id="srh_all_list">
                {brands ? <div>{brands}</div> : ''}
                {this.props.brands.length > 0 ? <ul style={{paddingBottom:'1px'}}>
                   {brands_list}
                  </ul> : ''}
                
                {products ? <div>{products}</div> : ''}
                {this.props.products.length > 0 ? <ul style={{paddingBottom:'5px'}}>
                   {product_list}
                </ul> : '' }
                {categories ? <div>{categories}</div> : ''}
                {categories_list ? <ul style={{marginBottom:'10px',overflow:'hidden'}}>
                     {categories_list}
                  </ul> : ''}
            </div> : ''}
            
            {this.props.recent_search.length > 0 ? <div className="recent_search_blk"><div><h2>Recent Searches</h2></div>
                {this.props.recent_search.length > 3 ?
                <Swiper {...params} key={recent_search.length}>
                  {recent_search}
                </Swiper> : <div><ul className="recent_search_ul">{recent_search}</ul></div>
                }
                
            </div> : ''}
            
            {this.props.trendings.length > 0 && !this.state.isSearched ? <div className="trnd_blk" style={{backgroundColor:'#fff',padding:'10px'}}>
              {trends ? <div>{trends}</div> : ''}
              {trendings_list ? <ul style={{paddingLeft:'8px'}}>
                {trendings_list}
              </ul>  : ''}
            </div> : ''}
            {this.props.popular_brands.length > 0 ?
            <div className="pop_brnds_blk" style={{backgroundColor:'#fff',marginTop:'10px'}}>
                {popular_brands_list ? <div>{pop_brnds}</div> : ''}
                {popular_brands_list ? <ul className="popular_brnds_lst">
                  {popular_brands_list}
                </ul> : ''}
            </div> : ''}
          </div>                                       
        </div> :
            <div className="mob_loading">
                <img src={require('./../../../assets/images/mob_loading.gif')} alt="Loading" role="presentation"/> 
            </div>
        }
        {((this.props.brands.length == 0 && this.props.products.length == 0 && this.props.categories.length == 0 && this.state.isSearched && this.props.isLoading)) ? 
            
            <div className="mob_loading no_deals_search">
                  <h4>No Deals Available</h4>
                 <Link to={'/home'}><button>Browse Other Deals</button></Link>
            </div>

        : ''}
        {/*<Footer />*/}
    </div> 
    );
  }
}

function mapStateToProps(state){
    return {
        search:state.posts.search,
        brands:state.posts.brands,
        products:state.posts.products,
        categories:state.posts.categories,
        trendings:state.posts.trendings,
        popular_brands: state.posts.popular_brands,
        recent_search:state.posts.recent_search,
        isLoading:state.posts.isLoading
    }
}
export default connect(mapStateToProps,actions)(Search);



/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/Search.js
 **/